import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900">
      {/* Header */}
      <header className="flex items-center p-4 border-b border-slate-700 sticky top-0 bg-slate-900 z-10">
        <button
          onClick={() => navigate(-1)}
          className="text-slate-400 hover:text-white mr-4"
        >
          ← 뒤로
        </button>
        <h1 className="text-lg font-semibold">개인정보 처리방침</h1>
      </header>

      <div className="p-4 max-w-lg mx-auto">
        <div className="prose prose-invert prose-sm max-w-none">
          <p className="text-slate-400 text-sm mb-6">
            최종 수정일: 2024년 1월 1일
          </p>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">1. 개인정보의 수집 및 이용 목적</h2>
            <p className="text-slate-300 leading-relaxed">
              Debate Battle(이하 "서비스")은 다음의 목적을 위하여 개인정보를 처리합니다. 
              처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 
              이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>회원 가입 및 관리: 회원제 서비스 제공에 따른 본인 식별·인증</li>
              <li>서비스 제공: 토론 매칭, 토론 기록 저장, 통계 제공</li>
              <li>서비스 개선: 서비스 이용 통계 분석, 서비스 개선</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">2. 수집하는 개인정보 항목</h2>
            <div className="bg-slate-800 rounded-lg p-4 mb-4">
              <h3 className="font-medium mb-2">필수 항목</h3>
              <ul className="text-slate-300 space-y-1 list-disc pl-5">
                <li>이메일 주소</li>
                <li>닉네임</li>
                <li>프로필 이미지 (Google 계정 연동 시)</li>
              </ul>
            </div>
            <div className="bg-slate-800 rounded-lg p-4">
              <h3 className="font-medium mb-2">자동 수집 항목</h3>
              <ul className="text-slate-300 space-y-1 list-disc pl-5">
                <li>서비스 이용 기록</li>
                <li>토론 참여 기록</li>
                <li>기기 정보 (브라우저 종류, OS)</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">3. 개인정보의 보유 및 이용 기간</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 
              개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>회원 정보: 회원 탈퇴 시까지</li>
              <li>토론 기록: 토론 종료 후 1년</li>
              <li>서비스 이용 기록: 3개월</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">4. 개인정보의 제3자 제공</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스는 원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 
              다만, 다음의 경우에는 예외로 합니다:
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>정보주체가 사전에 제3자 제공에 동의한 경우</li>
              <li>법령에 의하여 제공이 요구되는 경우</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">5. 개인정보의 파기</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 
              불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>전자적 파일: 복구가 불가능한 방법으로 영구 삭제</li>
              <li>기록물, 인쇄물: 파쇄 또는 소각</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">6. 정보주체의 권리·의무 및 행사방법</h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              정보주체는 다음과 같은 권리를 행사할 수 있습니다:
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5">
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
            <p className="text-slate-300 leading-relaxed mt-3">
              위 권리 행사는 서비스 내 설정 메뉴 또는 이메일을 통해 하실 수 있습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">7. 개인정보의 안전성 확보 조치</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>개인정보의 암호화</li>
              <li>해킹 등에 대비한 기술적 대책</li>
              <li>개인정보에 대한 접근 제한</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">8. 쿠키의 사용</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 쿠키(cookie)를 사용합니다. 
              쿠키는 웹사이트가 이용자의 컴퓨터 브라우저로 전송하는 소량의 정보입니다. 
              이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹브라우저 설정을 통해 
              쿠키 허용 여부를 결정할 수 있습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">9. 개인정보 보호책임자</h2>
            <div className="bg-slate-800 rounded-lg p-4">
              <p className="text-slate-300">
                개인정보 보호책임자: Debate Battle 운영팀<br />
                이메일: privacy@debatebattle.app
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">10. 개인정보 처리방침 변경</h2>
            <p className="text-slate-300 leading-relaxed">
              이 개인정보 처리방침은 2024년 1월 1일부터 적용됩니다. 
              변경사항이 있을 경우 서비스 공지사항을 통해 고지할 예정입니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
